import _defineProperty from "/var/jenkins_home/workspace/tingle.f418dd7e-8301-4eb7-bd6c-ad3162510800/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { client, previewClient } from './client';
import { sendMetric } from '@mrkt/features/metrics';
import { MetricTypes } from '@spotify-internal/semantic-metrics';
export var getClient = function getClient(preview) {
  return preview ? previewClient : client;
};
export var flattenSys = function flattenSys(contentType) {
  return function (entry) {
    return _objectSpread(_objectSpread({}, entry), {}, {
      sys: undefined,
      id: entry.sys.id,
      contentType: contentType || 'unknown'
    });
  };
};
export var pickFirst = function pickFirst(key) {
  return function (collection) {
    var _collection$items;

    if (!(collection !== null && collection !== void 0 && (_collection$items = collection.items) !== null && _collection$items !== void 0 && _collection$items.length)) {
      throw new Error("".concat(key, " not found"));
    }

    return collection.items[0];
  };
};
export var QUERY_COST = 'X-Contentful-Graphql-Query-Cost';
export var unwrapClientError = function unwrapClientError(error) {
  return error.response;
};
export var unwrapResponse = function unwrapResponse(key) {
  return function (response) {
    var _response$headers;

    if ((_response$headers = response.headers) !== null && _response$headers !== void 0 && _response$headers.has(QUERY_COST)) {
      var queryCost = parseInt(response.headers.get(QUERY_COST), 10);
      sendMetric({
        metric_type: MetricTypes.GAUGE,
        what: 's4a-frontdoor-contentful-query-cost',
        value: queryCost,
        tags: {
          pod: 'unknown',
          namespace: 'creator-web-metrics'
        }
      });
    }

    if (response.errors && response.errors.length) {
      throw response.errors[0];
    }

    if (!response.data) {
      throw new Error("".concat(key, " not found"));
    }

    return response.data;
  };
};